import { cast, types, Instance } from 'mobx-state-tree'
import { callAgroApi } from '@services/agroapi'
import { UserResponse } from '@services/responseTypes'

export const User = types
  .model('User', {
    id: types.identifier,
    name: types.maybeNull(types.string),
    email: types.string,
    avatar: types.maybeNull(types.string),
    settings: types.model({
      currency: types.maybeNull(types.string),
      lang: types.string,
      area_unit: types.string,
      weight_unit: types.string,
      soil_units: types.map(types.string),
    }),
  })
  .actions((self) => ({
    setLanguage(newLang: string) {
      self.settings.lang = newLang
    },
    setAreaUnit(newAreaUnit: string) {
      self.settings.area_unit = newAreaUnit
    },
    setWeightUnit(newWeightUnit: string) {
      self.settings.weight_unit = newWeightUnit
    },
    setName(newUserName: string) {
      self.name = newUserName
    },
    setSoilUnits(units: { [key: string]: string }) {
      self.settings.soil_units = cast(units)
    },
  }))
  .actions((self) => ({
    save(user: {
      name?: string | null
      lang?: string
      area_unit?: string
      weight_unit?: string
      soil_units?: { [key: string]: string }
    }) {
      return callAgroApi<UserResponse>(`/user`, 'PATCH', user).then(
        (response) => {
          self.setLanguage(response.data.lang)
          self.setAreaUnit(response.data.area_unit)
          self.setWeightUnit(response.data.weight_unit)
          self.setName(response.data.name)
          self.setSoilUnits(response.data.soil_units)
          return response
        }
      )
    },
  }))
  .views((self) => ({
    get info() {
      return {
        id: self.id,
        name: self.name,
        avatar: self.avatar,
        settings: self.settings,
      }
    },
    // Used before sending production values to backend
    get reverseWeightUnitFactor() {
      return self.settings.weight_unit === 'kg' ? 0.001 : 1
    },
    // Applied on data coming from backend
    get weightUnitFactor() {
      return self.settings.weight_unit === 'kg' ? 1000 : 1
    },
    get soilUnits() {
      return self.settings.soil_units.toJSON()
    },
  }))

export type IUser = Instance<typeof User>